import React, { FC, useState } from "react";
import { SearchIcon } from "../../assets/icons";
import Input from "../../components/UI/input/GgInput";

interface IHeader {
  searchItems: (value: string) => void;
}

const Header: FC<IHeader> = ({ searchItems }) => {
  return (
    <header className="users-header">
      <div className="title">Users</div>
      <Input
        id="search"
        onChange={(value) => searchItems(value)}
        type="text"
        icon={<SearchIcon />}
        placeholder="Search users"
      />
    </header>
  );
};

export default Header;
